import { useEffect, useRef, useState, useMemo } from "react";
import Icon from "../../../designSystem/a-atoms/icons/Icon";
import Button from "../../../designSystem/b-molecules/buttons/Button";
import style from "./Picture.module.css";
import { initializeApp } from "firebase/app";
import { getDownloadURL, getStorage, ref, uploadBytes } from "firebase/storage";
import { db, app } from "../../../configs/Firebase";
import { useSelector } from "react-redux";
import { update, ref as Ref2 } from "firebase/database";
import DialogNew from "../../../designSystem/c-organism/dialogs/DialogNew";

const Picture = (props) => {
  const org = useSelector((state) => state.orgStatus.value);
  const [dragActive, setDragActive] = useState(false);
  const inputRef = useRef();
  const storage = getStorage(app);
  const [imageURL, setImageURL] = useState("");
  const [imageIndex, setImageIndex] = useState(false);
  const [imgWidth, setImgWidth] = useState(0);
  const [imgHeight, setImgHeight] = useState(0);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (
      props.data.value &&
      (imageIndex || imageIndex === 0) &&
      org &&
      org.payload
    ) {
      setImgWidth(props.data.width);

      setImgHeight(props.data.height / (props.data.width / 204));

      // Set loading to true when starting to fetch
      setLoading(true);
      setImageURL(""); // Clear previous image URL

      getDownloadURL(
        ref(
          storage,
          org.payload + "/images/" + props.row.columns[imageIndex].value
        )
      )
      .then((url) => {
        setImageURL(url);
        setLoading(false);
      })
      .catch((error) => {
        console.error("Error loading image:", error);
        setLoading(false);
      });
    } else {
      // Reset loading state if conditions aren't met
      setLoading(false);
    }
  }, [imageIndex, props.data.value]);

  useEffect(() => {
    if (props.cellIndex !== false) {
      setImageIndex(props.cellIndex);
    }
  }, [props.cellIndex]);

  function onClickHandler(e) {
    // e.preventDefault();
    // e.stopPropagation();
    inputRef.current.click();
  }

  // handle drag events
  const handleDrag = function (e) {
    e.preventDefault();
    e.stopPropagation();
    if (e.type === "dragenter" || e.type === "dragover") {
      setDragActive(true);
    } else if (e.type === "dragleave") {
      setDragActive(false);
    }
  };

  const handleDrop = function (e, columnId) {
    e.preventDefault();
    e.stopPropagation();
    setDragActive(false);
    if (e.dataTransfer.files && e.dataTransfer.files[0]) {
      // at least one file has been dropped so do something
      // handleFiles(e.dataTransfer.files);
      var file = e.dataTransfer.files[0];
      let extension = file.type.replace(/(.*)\//g, "");
      let uuid = crypto.randomUUID();
      let filename = uuid + "." + extension;

      let reader = new FileReader();
      reader.readAsDataURL(file);

      reader.onload = (e) => {
        const image = new Image();
        image.src = e.target.result;
        image.onload = () => {
          const { height, width } = image;
          const storageRef = ref(storage, org.payload + "/images/" + filename);
          uploadBytes(storageRef, file).then((snapshot) => {
            update(Ref2(db), {
              [props.journeyRefURL +
              "/rows/" +
              props.row.id +
              "/columns/" +
              columnId +
              "/value"]: filename,
              [props.journeyRefURL +
              "/rows/" +
              props.row.id +
              "/columns/" +
              columnId +
              "/width"]: width,
              [props.journeyRefURL +
              "/rows/" +
              props.row.id +
              "/columns/" +
              columnId +
              "/height"]: height,
            });
          });
        };
      };
    }
  };

  const handleChange = function (e, columnId) {
    e.preventDefault();
    if (e.target.files && e.target.files[0]) {
      // at least one file has been selected so do something
      // handleFiles(e.target.files);
      var file = e.target.files[0];
      let extension = file.type.replace(/(.*)\//g, "");
      let uuid = crypto.randomUUID();
      let filename = uuid + "." + extension;

      let reader = new FileReader();
      reader.readAsDataURL(file);

      reader.onload = (e) => {
        const image = new Image();
        image.src = e.target.result;
        image.onload = () => {
          const { height, width } = image;
          const storageRef = ref(storage, org.payload + "/images/" + filename);
          uploadBytes(storageRef, file).then((snapshot) => {
            update(Ref2(db), {
              [props.journeyRefURL +
              "/rows/" +
              props.row.id +
              "/columns/" +
              columnId +
              "/value"]: filename,
              [props.journeyRefURL +
              "/rows/" +
              props.row.id +
              "/columns/" +
              columnId +
              "/width"]: width,
              [props.journeyRefURL +
              "/rows/" +
              props.row.id +
              "/columns/" +
              columnId +
              "/height"]: height,
            });
          });
        };
      };
    }
  };

  const [showLarge, setShowLarge] = useState(false);
  const [largeImageURL, setLargeImageURL] = useState(false);
  const [largeImageIndex, setLargeImageIndex] = useState(false);
  const [allImageURLs, setAllImageURLs] = useState({});
  
  function showLargeHandler() {
    setShowLarge(true);
    setLargeImageURL(imageURL);
    setLargeImageIndex(imageIndex);
    // Initialize with current image URL
    if (imageIndex !== false && imageURL) {
      setAllImageURLs({ [imageIndex]: imageURL });
    }
  }
  function hideLargeHandler() {
    setShowLarge(false);
  }

  // Pre-load all image URLs when dialog opens
  useEffect(() => {
    if (showLarge && org && org.payload && props.row && props.row.columns) {
      const urlPromises = [];
      
      // Create promises for all columns that have image values
      Object.keys(props.row.columns).forEach((colIndex) => {
        const column = props.row.columns[colIndex];
        if (column && column.value) {
          const colIndexNum = parseInt(colIndex);
          urlPromises.push(
            getDownloadURL(
              ref(storage, org.payload + "/images/" + column.value)
            ).then((url) => ({ index: colIndexNum, url }))
          );
        }
      });
      
      // Fetch all URLs concurrently and merge with existing URLs
      if (urlPromises.length > 0) {
        Promise.all(urlPromises).then((results) => {
          setAllImageURLs((prevURLs) => {
            const urlMap = { ...prevURLs };
            results.forEach(({ index, url }) => {
              urlMap[index] = url;
            });
            return urlMap;
          });
        });
      }
    }
  }, [showLarge, org, props.row]);

  // Calculate max column index once
  const maxColumnIndex = useMemo(() => {
    if (!props.row || !props.row.columns) return 0;
    const keys = Object.keys(props.row.columns);
    if (keys.length === 0) return 0;
    return Math.max(...keys.map(k => parseInt(k)));
  }, [props.row]);

  function slideshow(dir) {
    if (dir == "next") {
      const nextIndex = largeImageIndex + 1;
      if (nextIndex <= maxColumnIndex) {
        // Use pre-loaded URL if available, otherwise fetch
        if (allImageURLs[nextIndex]) {
          setLargeImageURL(allImageURLs[nextIndex]);
        } else if (props.row.columns[nextIndex] && props.row.columns[nextIndex].value) {
          // Fallback to fetching if not pre-loaded (shouldn't happen)
          getDownloadURL(
            ref(
              storage,
              org.payload +
                "/images/" +
                props.row.columns[nextIndex].value
            )
          ).then((url) => {
            setLargeImageURL(url);
          });
        } else {
          setLargeImageURL("noImage");
        }
        setLargeImageIndex(nextIndex);
      }
    } else {
      const prevIndex = largeImageIndex - 1;
      if (prevIndex >= 0) {
        // Use pre-loaded URL if available, otherwise fetch
        if (allImageURLs[prevIndex]) {
          setLargeImageURL(allImageURLs[prevIndex]);
        } else if (props.row.columns[prevIndex] && props.row.columns[prevIndex].value) {
          // Fallback to fetching if not pre-loaded (shouldn't happen)
          getDownloadURL(
            ref(
              storage,
              org.payload +
                "/images/" +
                props.row.columns[prevIndex].value
            )
          ).then((url) => {
            setLargeImageURL(url);
          });
        } else {
          setLargeImageURL("noImage");
        }
        setLargeImageIndex(prevIndex);
      }
    }
  }

  return (
    <div
      className={`${style.cell} ${props.editable && style.editable} ${
        dragActive ? style.dragActive : ""
      } ${imageURL && style.hasImage}`}
    >
      {imageURL ? (
        <img
          src={imageURL}
          
          height={imgHeight}
          onClick={showLargeHandler}
        />
      ) : loading && props.data.value && !props.editable ? (
        <div className={style.loadingPlaceholder}>
          <Icon>hourglass_empty</Icon>
        </div>
      ) : null}
      {props.data.value && !props.editable ? (
        imageURL ? (
          <>
            <DialogNew
              show={showLarge}
              onClose={hideLargeHandler}
              variants={["large"]}
            >
              <div className={style.largeView}>
                <span className={largeImageIndex === 0 ? style.disabled : ""}>
                  <Icon onClick={largeImageIndex === 0 ? null : () => slideshow("prev")}>
                    arrow_circle_left
                  </Icon>
                </span>
                {largeImageURL === "noImage" ? (
                  <div>
                    There's no image for this step ({largeImageIndex + 1})
                  </div>
                ) : largeImageURL ? (
                  <img
                    src={largeImageURL}
                    // width={imgWidth}
                    className={style.zoomedIn}
                  />
                ) : null}
                <span className={largeImageIndex === maxColumnIndex ? style.disabled : ""}>
                  <Icon onClick={largeImageIndex === maxColumnIndex ? null : () => slideshow("next")}>
                    arrow_circle_right
                  </Icon>
                </span>
              </div>
            </DialogNew>
          </>
        ) : null
      ) : props.editable ? (
        // <div>
        <form
          onDragEnter={(e) => handleDrag(e)}
          onDragLeave={(e) => handleDrag(e)}
          onSubmit={(e) => e.preventDefault()}
        >
          <label>
            <input
              ref={inputRef}
              type="file"
              multiple={false}
              onChange={(e) => handleChange(e, props.cellIndex)}
            />
            <Icon>cloud_upload</Icon>
            <div className={style.drag}>
              Drag image to upload
              <div>
                <small>(png, jpeg, gif)</small>
              </div>
            </div>{" "}
            or
            <div>
              <Button variants={["text"]} onClick={onClickHandler}>
                Browse Files
              </Button>
            </div>
          </label>
          {dragActive ? (
            <div
              className={style.dragOverlay}
              onDragEnter={(e) => handleDrag(e)}
              onDragLeave={(e) => handleDrag(e)}
              onDragOver={(e) => handleDrag(e)}
              onDrop={(e) => handleDrop(e, props.cellIndex)}
            ></div>
          ) : (
            ""
          )}
        </form>
      ) : (
        // </div>
        // <div>
        //   <Icon>image</Icon>
        // </div>
        null
      )}
    </div>
  );
};

export default Picture;
